module.exports = __webpack_public_path__ + "static/media/history-icon.61f8e206.svg";